import { render, staticRenderFns } from "./customerDetail.vue?vue&type=template&id=27dda110&scoped=true"
import script from "./customerDetail.vue?vue&type=script&lang=js"
export * from "./customerDetail.vue?vue&type=script&lang=js"
import style0 from "./customerDetail.vue?vue&type=style&index=0&id=27dda110&prod&lang=scss&scoped=true"
import style1 from "./customerDetail.vue?vue&type=style&index=1&id=27dda110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dda110",
  null
  
)

export default component.exports